import AppModal from "components/Modal"; 
import React, { 
    useEffect, 
    useState, 
}  from 'react';
import ReactDOM from "react-dom"; 
import { useAuth } from '../../../helpers/authContext';
import { Link } from "react-router-dom";

import {
    Alert,
    Button, 
  Card,
  CardBody,
  Col,
  FormGroup, 
} from "reactstrap"; 
import { useToast } from "components/ui/use-toast"; 
import useModal from "helpers/useModal";
import LoginModal from "./LoginModal";
import { getUser } from "services/user-service";
import { getPosts } from "services/posts-service";
import { isLoggedWithKeychain } from "services/dsteem-service";
import { transferKeychain } from "helpers/keychain";
import { transferWithWif } from "helpers/steem";  
type Props = {
  isShowing: boolean,
  hide: any, 
  author?:string,
  permlink?:string,
  edit?:boolean,
  editItem?:any,
  onSuccess?: (data: {
    username: string;
    wif?: string;
  }) => void;
}

export const PromoteModal = ({ isShowing, hide, author="", permlink=""}: Props) => {   
    const { user, autologin } = useAuth(); 
    const [requiredActive, setRequiredActive] = useState<any>(true);
    const keychainLogin = isLoggedWithKeychain(autologin);
    const [availableSBD, setAvailableSBD] = useState<any>(0);
    const [promotionValue, setPromotionValue] = useState<any>(0);
    const [highestSBD, setHighestSBD] = useState<any>(0);
    const [lowestSBD, setLowestSBD] = useState<any>(0);
    const [promotedPosts, setPromotedPosts] = useState<any>([]);
    const [showConfirm, setShowConfirm] = useState(false);
    const { isOpenLoginModal, toggleLoginModal  } = useModal();
    const { toast } = useToast();
    useEffect(()=> { 
        async function getAvailableSBD (){
            try {
                const [userInfo] = await Promise.all([ 
                    getUser(user),
                ]);
                setAvailableSBD(parseFloat(userInfo?.sbd_balance) || 0)
            } catch (error) {
                toast({title:"Error", description:error, variant:"rose_red"});
            }
            
        }
        getAvailableSBD();
        async function getPromotedPosts() {
            try {
                let promotedData = []; 
                const promoted = await getPosts(20, "", "promoted", true, "", "", "get_ranked_posts", false);
                promotedData = promoted?.posts || []; 
                setPromotedPosts(promotedData);
            } catch (error) {
                toast({title:"Error", description:error, variant:"rose_red"});
            } 
        }
        getPromotedPosts();
    },[]);
    useEffect(()=> {
        let highest = parseFloat(promotedPosts[0]?.promoted) || 0;
        let lowest = parseFloat(promotedPosts[promotedPosts.length-1]?.promoted) || 0; 
        setHighestSBD(highest);
        setLowestSBD(lowest);
    },[promotedPosts]);


    const handlePromote = async (newWif = "") => {
        console.log(promotionValue, newWif);
        if (promotionValue) {
            if (promotionValue > availableSBD) {
                toast({
                title:"Failed promoting post.",
                description:"You don't have enough SBD",
                variant:"rose_red"
                });
                return;
            }
            const fn = keychainLogin ? transferKeychain : transferWithWif;
            const account = keychainLogin ? user : autologin;
            let res:any = await fn(account, parseFloat(promotionValue), "SBD", "null", `@${author}/${permlink}`, newWif);
            if (!res.success) { 
                if(res?.message.toString().includes("Missing Active Authority")){ 
                    setRequiredActive(true);
                    toggleLoginModal();
                    return;
                } else {
                   toast({
                        title:"Failed promoting post.",
                        description:res,
                        variant:"rose_red"
                    }); 
                }
                
            }else {
                toast({
                title:"Post promoted successfully.",
                description:"Your changes may take a few minutes to take effect.",
                variant:"wild_green"
                }); 
                setPromotionValue(0);
                setShowConfirm(false);
                hide();
            }
        }else{
            toast({
                title:"Failed promoting post.",
                description:"You need to set an amount.",
                variant:"rose_red"
            });
        }
    }
    const renderForm = (
        <div className="modal-body post-editor-body p-0">
        <Card className="no-shadow border-0 h-100">
            {user && (
                <CardBody className="px-lg-3 py-0 body-gray h-100">
                    <div className="post-editor-wrapper">
                        <div className="post-editor-scroll-area px-3">
                            <Col md="12" className="mt-3">
                                <p className="promotion-description">
                                    You can send SBD to <Link to="/u/null">@null</Link> to promote any post on the Steem blockchain.
                                    Your promoted post will be shown as a special post in the feeds, giving you more visibility
                                    and potentially increasing your rewards.
                                    
                                    Promoted posts remain active until they expire. If another user promotes a post with a higher amount,
                                    your post may be displaced to a lower position.
                                    
                                    The more you send, the higher your chances of appearing.
                                </p> 
                                <ul className="promotion-description">
                                    <li><b>{highestSBD.toFixed(3)} SBD</b> to appear in first position</li>
                                    <li><b>{lowestSBD.toFixed(3)} SBD</b> to get promoted on Speak on Steem</li>
                                </ul>
                                <p className="mt-2 text-muted">
                                    You will promote <code>/@{author}/{permlink}</code>
                                </p>
                                <FormGroup>
                                    <div className="input-icon-group">
                                        <i className="fas fa-coins input-icon" />
                                        <input type="number" className="form-control fancy-input" name="val" placeholder="Promotion Value (SBD)" value={promotionValue} onChange={(e) => setPromotionValue(parseFloat(e.target.value))} />
                                    </div>
                                    <span
                                        className="text-muted mt-2 d-inline-block"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => setPromotionValue(availableSBD)}
                                        >
                                        Available: <b>{availableSBD.toFixed(3)} SBD</b>
                                    </span>
                                </FormGroup> 
                                {!availableSBD && (
                                    <Alert color="danger">You don’t have any SBD available. Buy SBD in the <a href="https://steemitwallet.com/market" target="_blank">Internal Market</a> or on <a href="https://www.htx.com/es-es" target="_blank">exchanges</a>.</Alert>
                                )} 
                            </Col>
                        </div>
                        <div className="post-editor-buttons px-3">
                            <Button color="default" className="w-100 btn-fancy" onClick={() => {
                                if (promotionValue > 0) {
                                    setShowConfirm(true);
                                } else {
                                    toast({title:"Set an amount", description:"You need to set an amount to promote.", variant:"rose_red"});
                                }
                            }}>
                                Next <i className="fas fa-chevron-right ml-2" />
                            </Button> 
                        </div>
                    </div>
                </CardBody>
            )}
            {!user && (<p className="p-3">Please log in to promote posts.</p>)}
        </Card>
        </div>
    );

  return (
    isShowing ? ReactDOM.createPortal(
      <React.Fragment>
        <AppModal
          isShowing={isShowing}
          hide={hide}
          size="md"
          header="Promotion"
        >
            {renderForm}
            <AppModal isShowing={showConfirm} hide={() => setShowConfirm(false)} size="md" header="Confirm Promotion">
                <div className="p-3 text-scheme">
                    <p className="text-muted">You are about to promote this post. Please review the details:</p>
                    <div className="mb-4 p-3 border rounded bg-speem-confirm">
                        <div className="mb-2">
                           <i className="fas fa-link mr-2 text-speem" /> <strong>Target:</strong> <span className="ml-2">@{author}/{permlink}</span>
                        </div>
                        <div className="mb-0">
                           <i className="fas fa-coins mr-2 text-speem" /> <strong>Amount:</strong> <span className="ml-2">{parseFloat(promotionValue).toFixed(3)} SBD</span>
                        </div>
                    </div>
                    <p className="small text-muted mb-4"><i className="fas fa-info-circle mr-1" /> Promotions increase visibility in the promoted feed.</p>
                    <div className="d-flex gap-3 mt-4">
                        <Button color="secondary" onClick={() => setShowConfirm(false)} className="w-100 mr-2 btn-fancy">
                            Cancel
                        </Button>
                        <Button color="default" onClick={() => handlePromote()} className="w-100 btn-fancy position-relative">
                            {keychainLogin ? (
                                <>
                                Confirm with
                                <img className="icon icon-sm ml-1" src="/assets/img/keychain.svg" />
                                </>
                            ) : (
                                "Confirm"
                            )}
                        </Button>
                    </div>
                </div>
            </AppModal>
        </AppModal>
        <LoginModal
            isShowing={isOpenLoginModal}
            hide={toggleLoginModal}
            requiredActive={requiredActive}
            onSuccess={({ wif }) => { 
                if (wif) {
                handlePromote(wif);
                } 
            }}
            />
      </React.Fragment>, document.body
    ) : null)
};

export default PromoteModal;